import { useMemo } from 'react';
import { useComponentEntries } from '../hook.component-entries.js';

function useStudentEntries(timespan) {
  const entries = useComponentEntries(timespan);
  return useMemo(() => entries.data?.reduce((acc, curr) => {
    if (curr.status.isShared || curr.status.state === "completed") {
      acc.finishedEntries.push(curr);
    } else {
      acc.unfinishedEntries.push(curr);
    }
    return acc;
  }, {
    unfinishedEntries: [],
    finishedEntries: []
  }) ?? {
    unfinishedEntries: [],
    finishedEntries: []
  }, [entries.data]);
}

export { useStudentEntries };
//# sourceMappingURL=hook.student-entries.js.map
